import apiHandler from '@api/ApiHandler.ts';

export const createDatabase = (
  data: FormData,
  callback: (data: any) => void
) => {
  apiHandler
    .post(`/database/create_database/`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

export const addFilesToDatabase = (
  data: FormData,
  callback: (data: any) => void
) => {
  apiHandler
    .post(`/database/upload_files/`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

export const updateDocumentInstanceVersion = (
  data: any,
  callback: (data: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .patch(`/document-instance-versions/save-draft/`, data)
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      console.error('Error:', error);
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

export const generateDocumentInstanceVersion = (
  data: any,
  callback: (data: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .post(`/document-instance-versions/generate/`, data)
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      console.error('Error:', error);
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

export const createEmptyDocumentInstance = (
  data: { generator: number; case?: number },
  callback: (data: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .post(`/document-instance-versions/create-empty-document-instance/`, data)
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      console.error('Error creating document instance:', error);
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

// Throw away the instance behind a create page the user left without saving
// a draft or generating (ZLAYT-1257). The backend only discards an unsaved
// instance and answers 409 once it was saved, so a call that races a save is
// harmless; nothing here needs the answer.
export const discardUnsavedDocumentInstance = (versionId: number) => {
  apiHandler
    .post(`/document-instance-versions/${versionId}/discard-unsaved/`, {})
    .catch(() => {});
};

export const checkExistingDocument = (
  caseId: number,
  templateId: number,
  callback: (data: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .get(
      `/document-instance-versions/check-existing-document/?case_id=${caseId}&template_id=${templateId}`
    )
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      console.error('Error checking existing document:', error);
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

export const linkCaseToDocument = (
  documentInstanceId: number,
  caseId: number,
  callback: (data: any) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .post(`/document-instance-versions/${documentInstanceId}/link-case/`, {
      case_id: caseId,
    })
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      console.error('Error linking case:', error);
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

// List generated document instance versions by case
export const getGeneratedDocumentsByCase = (
  caseId: number,
  callback: (rows: any[]) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .get(`/document-instance-versions/by-case/?case_id=${caseId}`)
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      console.error('Error fetching generated documents by case:', error);
      if (errorCallback) errorCallback(error);
    });
};

// Unified: demand letters + deposition summaries + use cases for a case
export const getCaseDocumentsByCase = (
  caseId: number,
  callback: (rows: any[]) => void,
  errorCallback?: (error: any) => void
) => {
  apiHandler
    .get(`/case-documents/?case_id=${caseId}`)
    .then((response) => {
      callback(response as any);
    })
    .catch((error) => {
      console.error('Error fetching case documents:', error);
      if (errorCallback) errorCallback(error);
    });
};
